// Auto-written by setup.sh — re-run the script to update
const ABSOLUTE_API = "https://mail-api.mckodev.com.ng";

// On a *.mcmail.ng tenant host the API is reached through the SAME origin
// (nginx proxies /v1/ to the backend — see sites-available/mcmail.ng).
//
// Why: the session cookie is SameSite=Lax. From webmail.mckodev.com.ng the API
// is same-site so the cookie rides along, but *.mcmail.ng -> mckodev.com.ng is
// cross-site, so the browser withholds it and every authenticated call fails
// with 401 "missing bearer token". Same-origin makes the cookie first-party and
// also sidesteps third-party-cookie deprecation.
export const API_BASE =
  typeof window !== "undefined" &&
  window.location.hostname.toLowerCase().endsWith(".mcmail.ng")
    ? ""
    : ABSOLUTE_API;
